import React from 'react';
const SvgDwfxThumbnail = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg viewBox="0 0 100 100" width="1em" height="1em" {...props}>
      <path fill="#0C5089" d="M11 3v95h79V23l-18-2-2-18H11z" />
      <path fill="#FFF" d="M15 7h55l16 16v50H15V7z" />
      <path fill="#1273C5" d="M70 3l20 20H70V3z" />
      <path opacity={0.2} fill="#1B3F63" d="M70 23h20v20L70 23z" />
      <g>
        <circle fill="#059DD2" cx={50} cy={41} r={23} />
        <path
          fill="#37B9E5"
          d="M50 18c-1.3 0-2.5.1-3.7.3C40.2 21.6 36 28 36 35.5 36 46.3 44.7 55 55.5 55c7.5 0 13.9-4.2 17.2-10.3.2-1.2.3-2.4.3-3.7 0-12.7-10.3-23-23-23z"
        />
        <path
          fill="#FF9B0D"
          d="M71 50.4c-.9-12.2-19.3-22.7-34.5-21.2-.5 2.1-.5 3.1-.5 3.1l-5.2-2.7 7.9-5.2s-.7 1.5-1.6 3.1c14-1 34 8 33.9 22.9z"
        />
        <path
          fill="#FFE44D"
          d="M28.6 50.7c10.6 6.6 30.3-2.1 38.4-15.5-1.4-1.7-2.3-2.2-2.3-2.2l5.4-2.6-.5 9.6s-.8-1.4-1.5-3.2c-7.8 12.1-27.4 23-39.5 13.9z"
        />
        <g fill="#EB3434">
          <path d="M42 27.5c1.4-4.1 3.6-7.5 6.8-9.5-3.9 2-6.6 5.4-8.2 9.4.5 0 1 0 1.4.1zM41.5 29.1c-.5 0-1-.1-1.4-.1-2.9 9.4-.7 21.7 4.2 29.7-1.9-.1-3.5 0-3.5 0l8.3 4.6v-5.9s-.9.5-2.9 1.1c-5.5-8.4-7.1-20.3-4.7-29.4z" />
        </g>
      </g>
      <g fill="#FFF">
        <path d="M23.1 93V78.3h3.8c4.7 0 7.6 2.4 7.6 7.1 0 5.2-3.5 7.5-8.4 7.5h-3zm1.7-1.4H26c4.1 0 6.6-1.8 6.6-6.1 0-3.7-2.1-5.7-5.8-5.7h-2v11.8zM39.7 93l-4.2-14.7h1.8l3.5 12.9 3.7-12.9h2l3.6 12.9 3.5-12.9h1.7L51.1 93H49l-3.6-13-3.7 13h-2zM57.4 93V78.3h7.4v1.4h-5.6v5.1h5.4v1.4h-5.4V93h-1.8zM65.7 93l5.4-7.7-4.9-7h2l4 5.9 4-5.9h1.9l-4.9 7 5.3 7.7h-2.1L72 86.3 67.7 93h-2z" />
      </g>
    </svg>
  );
});
export default SvgDwfxThumbnail;
SvgDwfxThumbnail.iconName = 'dwfx-thumbnail';
SvgDwfxThumbnail.displayName = 'SvgDwfxThumbnail';
